<template>
  <div class="bgfff Classify" :style="{boxShadow:boxShadow?'0px 8px 12px 0px rgba(223, 223, 223, 0.5)':'initial'}">
    <ul class="nav flex align-items-end">
      <li class="AllActive" @mouseover="showClassify = true" @mouseleave="handleShowClassifyLeave">
        <div>
          <van-icon :name="require('../assets/fenlei-icon.png')" size="20px" class="icon" />
          <span>全部分类</span>
        </div>
        <transition name="fade">
          <div v-if="showClassify" class="classify-box" :class="{'bgfff w1200':showClassifyProduct}">
            <ul>
              <!-- <li v-for="(item,index) in categoryList" :key="item.Id" :class="showClassifyProduct&&showClassifyIndex==index?'actived':''" -->
              <li v-for="(item,index) in categoryList" :key="item.Id" @mouseover="enter(index)" @click.stop="goSearchPage(null,item,1)">
                {{ item.ClassifyName }}
                <div class="classify-product-parent" :class="showClassifyProduct&&showClassifyIndex==index?'show':'hide'">
                  <van-grid :border="false" :column-num="7">
                    <van-grid-item v-for="(v) in categoryList[index].Children.filter(w=>w.Id!='')" :key="v.Id" @click.stop="goSearchPage(item,v,2)">
                      <van-image :src="_getPic(v.IconUrl,true)" fit="scale-down" width="80px" height="80px" />
                      <div class="c222 lhn mt10 fw400">{{ v.ClassifyName }}</div>
                    </van-grid-item>
                  </van-grid>
                </div>
              </li>
            </ul>
          </div>
        </transition>
      </li>
      <li v-for="(item,index) in Navigations" :key="index">
        <!-- <div v-if="item.Name != '新品抢购'" class="ihover" :class="active == (index + 1)?'c0F6EEA fw600 f14':'f14 fw400'" -->
        <div v-if="item.Name != '新品抢购'" class="ihover f14 fw400" @click.stop="goRouter(item)">
          <!-- <van-icon :name="require('../assets/linquanzhongxin-icon.png')" size="16px" v-if="item.Name == '领券中心'"/> -->
          {{ item.Name }}
        </div>
        <van-image v-else :src="require('../assets/xinpinqianggou-icon.png')" width="76px" height="28px" class="img" @click.stop="goRouter(item)" />
      </li>
    </ul>
  </div>
</template>
<script>
import { LinkTypeCode } from '../dictionary/base.js'
import { BaseMixin } from '@/mixins/BaseMixin'
export default {
  name: 'Classify',
  mixins: [BaseMixin],
  props: {
    AllActive: {
      type: Boolean,
      default: false
    },
    active: {
      type: Number,
      default: 0
    },
    boxShadow: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      LinkTypeCode,
      showClassify: false,
      showClassifyIndex: null,
      showClassifyProduct: false,
      categoryList: [],
      Navigations: []
    }
  },
  mounted() {
    this.getClassifyDatas()
    this.getHomePageShowData()
  },
  methods: {
    // 获取分类
    async getClassifyDatas() {
      this.$hys.openLoading()
      const res = await this.getAction(
        '/api_goods/OperatingClassify/GetListOwner'
      )
      this.$hys.clearLoading()
      if (!res.IsSuccess) {
        this.$toast({ position: 'bottom', message: res.Msg })
      } else {
        res.Data.unshift({
          Id: '',
          ClassifyName: '查看全部',
          Children: res.Data
        })
        this.categoryList = res.Data
      }
    },
    // 获取分类导航
    async getHomePageShowData() {
      this.$hys.openLoading()
      const res = await this.getAction(
        '/api_basedata/HomePage/GetAdvertisementsNavigations?enumTerminal=1'
      )
      this.$hys.clearLoading()
      if (res.IsSuccess) {
        res.Data.Navigations.unshift({
          Name: '首页',
          Id: ''
        })
        this.Navigations = res.Data.Navigations
      } else {
        this.$toast({ position: 'bottom', message: res.Msg })
      }
    },
    handleShowClassifyLeave() {
      this.showClassify = false
      this.showClassifyProduct = false
      this.showClassifyIndex = null
    },
    enter(index) {
      this.showClassifyProduct = true
      this.showClassifyIndex = index
    },
    goRouter(item) {
      if (item.Name === '首页') {
        this.$route.path === '/' ? location.reload() : this.$router.push({ path: '/' })
      } else {
        this._jump(
          this._getTurnUrl(item.LinkType, item.LinkValue),
          item.LinkValue,
          null,
          item.Name
        )
      }
    },
    goSearchPage(pitem, item, l) {
      // console.log(pitem, item, l)
      if (
        this.$route.path.indexOf('/') != -1 &&
                this.$route.path.replace('/', '') == 'SearchPage'
      ) {
        this.$bus.$emit('changeSearchClassify', pitem, item, l)
      } else {
        this.$router.push({ name: LinkTypeCode.SearchPage, params: { pclassify: pitem, classify: item, level: l }})
      }
      this.handleShowClassifyLeave()
    }
  }
}
</script>
<style lang="less" scoped>
.Classify {
  position: relative;
  //box-shadow: 0px 8px 12px 0px rgba(223, 223, 223, 0.5);
  z-index: 2;

  ul.nav {
    margin: 0 auto;
    min-width: 1200px;
    max-width: max-content;

    li.AllActive {
      margin-right: 30px !important;
      padding-left: 0 !important;
    }

    > li {
      position: relative;
      display: inline-block;
      margin: 0 25px 0 30px;
      height: 44px;
      color: #222222;
      line-height: 44px;
      cursor: pointer;

      &:first-child {
        margin-right: 30px;
        margin-left: 0;
        width: 180px;
        height: 44px;
        line-height: 44px;
      }

      &:last-child {
        margin-right: 0;
        // padding-left: 20px;
      }

      /deep/.van-image.img {
        top: 10px;
      }

      &:not(:first-child) {
        /deep/.van-icon {
          position: absolute;
          top: 50%;
          left: 0;
          transform: translateY(-50%);
        }
      }

      .classify-box {
        position: absolute;
        top: 44px;
        right: 0;
        left: 0;
        z-index: 2;
        height: 461px;

        > ul {
          overflow-y: auto;
          width: 170px;
          height: 461px;
          background: #0F6EE9;

          &::-webkit-scrollbar {
            /* 滚动条整体样式 */
            width: 10px;

            /* 高宽分别对应横竖滚动条的尺寸 */
            height: 1px;
          }

          &::-webkit-scrollbar-thumb {
            /* 滚动条里面小方块 */
            border-radius: 10px;
            background: #2C84F7;
            box-shadow: inset 0 0 5px rgba(0, 0, 0, .2);
          }

          &::-webkit-scrollbar-track {
            border-radius: 10px;
            background: #EDEDED;

            /* 滚动条里面轨道 */
            box-shadow: inset 0 0 5px rgba(0, 0, 0, .2);
          }

          > li {
            border-top: 1px solid #1A74E9;
            padding: 15px 20px;
            font-size: 14px;
            font-weight: 400;
            text-align: left;
            color: #FFFFFF;
            line-height: 1.4;

            &:first-child {
              // text-align: center;
            }
          }

          > li.actived {
            font-weight: 600;
            color: #0F6EE9;
            background: #FFFFFF;
          }

          .classify-product-parent {
            position: absolute;
            top: 0;
            left: 170px;
            overflow-y: auto;
            border-top: 1px solid #E7E7E7;
            padding-bottom: 40px;
            padding-left: 10px;
            width: calc(1200px - 170px);
            height: 421px;
            background: #FFFFFF;

            /deep/.van-grid {
              padding-right: 100px;

              /deep/.van-grid-item__content {
                padding: 40px 0 0 50px;
              }
            }

            &::-webkit-scrollbar {
              /* 滚动条整体样式 */
              width: 10px;

              /* 高宽分别对应横竖滚动条的尺寸 */
              height: 1px;
            }

            &::-webkit-scrollbar-thumb {
              /* 滚动条里面小方块 */
              border-radius: 10px;
              background: #BABABA;
              box-shadow: inset 0 0 5px rgba(0, 0, 0, .2);
            }

            &::-webkit-scrollbar-track {
              border-radius: 10px;
              background: #EDEDED;

              /* 滚动条里面轨道 */
              box-shadow: inset 0 0 5px rgba(0, 0, 0, .2);
            }
          }
        }
      }
    }
  }

  .AllActive {
    background: url("../assets/fenlei-title-bg.png") no-repeat;
    background-size: 100% 100%;

    > div {
      color: #FFFFFF;

      /deep/.van-icon.icon {
        position: absolute;
        top: 50%;
        margin-left: -15px;
        transform: translateY(-50%);
      }

      > span {
        margin-left: 15px;
      }
    }
  }
}

.show {
  display: block;
}

.hide {
  display: none;
}
</style>
